// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/assay_limits.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_quanterix_common_extensions_v1_field_options } from "../../../common/extensions/v1/field_options_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/assay_limits.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_assay_limits: GenFile = /*@__PURE__*/
  fileDesc("CjpxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvYXNzYXlfbGltaXRzLnByb3RvEidxdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEiywcKC0Fzc2F5TGltaXRzEg8KAmlkGAEgASgJSACIAQESHAoHcGxleF9pZBgCIAEoCUIGgrUYAhgBSAGIAQESHQoIYXNzYXlfaWQYAyABKAlCBoK1GAIYAUgCiAEBEhAKA2xvZBgEIAEoAUgDiAEBEhEKBGxsb3EYBSABKAFIBIgBARIRCgR1bG9xGAYgASgBSAWIAQESKwoedWxfY2FsaWJyYXRvcl9jb25jZW50cmF0aW9uX2N2GAcgASgBSAaIAQESIQoUdWxfY2FsaWJyYXRvcl9hZWJfY3YYCCABKAFIB4gBARIuCiF1bF9saW1pdF9jb250cm9sX2NvbmNlbnRyYXRpb25fY3YYCSABKAFICIgBARIkChd1bF9saW1pdF9jb250cm9sX2FlYl9jdhgKIAEoAUgJiAEBEi4KIXVsX2xpbWl0X3Vua25vd25fY29uY2VudHJhdGlvbl9jdhgLIAEoAUgKiAEBEiQKF3VsX2xpbWl0X3Vua25vd25fYWViX2N2GAwgASgBSAuIAQESKgodbWluX3JlcGxpY2F0ZXNfcGVyX2NhbGlicmF0b3IYDSABKAVIDIgBARIyCiVtaW5fcmVwbGljYXRlc19wZXJfY29udHJvbF9vcl91bmtub3duGA4gASgFSA2IAQESKgodbWF4X251bWJlcl9kcm9wcGVkX3JlcGxpY2F0ZXMYDyABKAVIDogBARInChpyZWNvdmVyeV9jdXRvZmZfY2FsaWJyYXRvchgQIAEoAUgPiAEBQgUKA19pZEIKCghfcGxleF9pZEILCglfYXNzYXlfaWRCBgoEX2xvZEIHCgVfbGxvcUIHCgVfdWxvcUIhCh9fdWxfY2FsaWJyYXRvcl9jb25jZW50cmF0aW9uX2N2QhcKFV91bF9jYWxpYnJhdG9yX2FlYl9jdkIkCiJfdWxfbGltaXRfY29udHJvbF9jb25jZW50cmF0aW9uX2N2QhoKGF91bF9saW1pdF9jb250cm9sX2FlYl9jdkIkCiJfdWxfbGltaXRfdW5rbm93bl9jb25jZW50cmF0aW9uX2N2QhoKGF91bF9saW1pdF91bmtub3duX2FlYl9jdkIgCh5fbWluX3JlcGxpY2F0ZXNfcGVyX2NhbGlicmF0b3JCKAomX21pbl9yZXBsaWNhdGVzX3Blcl9jb250cm9sX29yX3Vua25vd25CIAoeX21heF9udW1iZXJfZHJvcHBlZF9yZXBsaWNhdGVzQh0KG19yZWNvdmVyeV9jdXRvZmZfY2FsaWJyYXRvcmIGcHJvdG8z", [file_quanterix_common_extensions_v1_field_options]);

/**
 * Contains user-defined and / or derived threshold criteria for evaluating
 * quality of data in experimental results
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.AssayLimits
 */
export type AssayLimits = Message<"quanterix.simoa_one.analysis_app_api.v1.AssayLimits"> & {
  /**
   * Unique identifier (UUID)
   *
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * Unique identifier (UUID) of the parent plex of this limit set
   *
   * @generated from field: optional string plex_id = 2;
   */
  plexId?: string;

  /**
   * Unique identifier (UUID) of the parent assay of this limit set
   *
   * @generated from field: optional string assay_id = 3;
   */
  assayId?: string;

  /**
   * Limit of Detection: the lowest concentration of an analyte that can be
   * differentiated from background noise
   *
   * @generated from field: optional double lod = 4;
   */
  lod?: number;

  /**
   * Lower Limit of Quantification: the lowest concentration of an analyte
   * that can be accurately and precisely measured
   *
   * @generated from field: optional double lloq = 5;
   */
  lloq?: number;

  /**
   * Upper Limit of Quantification: the highest concentration of an analyte
   * that can be accurately and precisely measured
   *
   * @generated from field: optional double uloq = 6;
   */
  uloq?: number;

  /**
   * Upper Limit of Calibrator Concentration Coefficient of Variation:
   * The maximum allowable CV of concentration measurements within a
   * replicate group of Calibrators
   *
   * @generated from field: optional double ul_calibrator_concentration_cv = 7;
   */
  ulCalibratorConcentrationCv?: number;

  /**
   * Upper Limit of Calibrator AEB Coefficient of Variation:
   * The maximum allowable CV of AEB measurements within a
   * replicate group of Calibrators
   *
   * @generated from field: optional double ul_calibrator_aeb_cv = 8;
   */
  ulCalibratorAebCv?: number;

  /**
   * Upper Limit of Calibrator Concentration Coefficient of Variation:
   * The maximum allowable CV of concentration measurements within a
   * replicate group of Calibrators
   *
   * @generated from field: optional double ul_limit_control_concentration_cv = 9;
   */
  ulLimitControlConcentrationCv?: number;

  /**
   * Upper Limit of Control AEB Coefficient of Variation:
   * The maximum allowable CV of AEB measurements within a
   * replicate group of Controls
   *
   * @generated from field: optional double ul_limit_control_aeb_cv = 10;
   */
  ulLimitControlAebCv?: number;

  /**
   * Upper Limit of Unknown Concentration Coefficient of Variation:
   * The maximum allowable CV of concentration measurements within a
   * replicate group of samples with Unknown concentrations
   *
   * @generated from field: optional double ul_limit_unknown_concentration_cv = 11;
   */
  ulLimitUnknownConcentrationCv?: number;

  /**
   * Upper Limit of Unknown AEB Coefficient of Variation:
   * The maximum allowable CV of AEB measurements within a
   * replicate group of samples with Unknown concentrations
   *
   * @generated from field: optional double ul_limit_unknown_aeb_cv = 12;
   */
  ulLimitUnknownAebCv?: number;

  /**
   * Minimum number of replicates required to produce a valid result
   * for a Calibrator
   *
   * @generated from field: optional int32 min_replicates_per_calibrator = 13;
   */
  minReplicatesPerCalibrator?: number;

  /**
   * Minimum number of replicates required to produce a valid result
   * for a sample of Control or Unknown type
   *
   * @generated from field: optional int32 min_replicates_per_control_or_unknown = 14;
   */
  minReplicatesPerControlOrUnknown?: number;

  /**
   * The maximum number of replicates of a sample that are allowed to be
   * excluded from analysis before a warning / error is triggered
   *
   * @generated from field: optional int32 max_number_dropped_replicates = 15;
   */
  maxNumberDroppedReplicates?: number;

  /**
   * The acceptable range for % recovery value of Calibrators:
   * This value decides the allowable range for % recovery.
   * If this value is configured as 5%, it would check % recovery value is < 95% or > 105%
   *
   * @generated from field: optional double recovery_cutoff_calibrator = 16;
   */
  recoveryCutoffCalibrator?: number;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.AssayLimits.
 * Use `create(AssayLimitsSchema)` to create a new message.
 */
export const AssayLimitsSchema: GenMessage<AssayLimits> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_assay_limits, 0);

